import React, { useState } from 'react';
import { 
  MessageSquare, 
  FileSearch, 
  PenTool, 
  Code2, 
  Rocket,
  CheckCircle
} from 'lucide-react';
import SolutionsDialog from '../solutions/SolutionsDialog';

// ... keep existing workflowSteps array ...

export default function WorkProcess() {
  const [showConsultation, setShowConsultation] = useState(false);

  return (
    <section className="py-16 bg-gray-50 dark:bg-gray-800">
      {/* ... keep existing JSX until the button ... */}

      <div className="mt-12 text-center">
        <button
          onClick={() => setShowConsultation(true)}
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors duration-300"
        >
          Start Your Project
        </button>
      </div>

      <SolutionsDialog 
        isOpen={showConsultation}
        onClose={() => setShowConsultation(false)}
      />
    </section>
  );
}